/* Spanish catalog mirroring locale-investments-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'investments.reviewAndEdit': 'Revisar y editar',
  'investments.editSourceFact': 'Editar dato de origen',
  'investments.correctedSourceFactHelp': 'Corrige solo datos comprobados con el documento original. El cambio queda registrado con el usuario y la marca de tiempo.',
  'investments.saveCorrection': 'Guardar corrección',
  'investments.addOptionalComment': 'Añadir comentario (opcional)',
  'investments.reviewNoteOptional': 'Comentario de revisión (opcional)',
  'investments.openingReconciliation': 'Inversiones de apertura frente al libro mayor',
  'investments.openingReconciliationHelp': 'Las inversiones de apertura mostradas se comparan con las cuentas de inversión del saldo de apertura del libro mayor. Se aceptan diferencias monetarias de hasta {{tolerance}} inclusive.',
  'investments.openingRegisterValue': 'Inversiones mostradas',
  'investments.openingLedgerValue': 'Apertura del libro mayor',
  'investments.total': 'Total',
  'investments.openingLedgerMismatch': 'Las inversiones de apertura y el libro mayor no concilian.',
  'investments.details': 'Detalles',
  'investments.eventDetails': 'Detalles del evento',
  'investments.holdingDetails': 'Detalles de la posición',
  'investments.amount': 'Importe',
  'investments.openingRepairTaxReason': 'El tratamiento fiscal debe confirmarse con el extracto anual u otra evidencia.',
  'investments.openingRepairReason': 'Posición de apertura documentada y revisada antes de la venta.',
  'investments.authenticationRequired': 'Inicia sesión para usar el registro de inversiones.',
  'investments.businessInvalid': 'Elige una empresa válida.',
  'investments.businessNotFound': 'No se encontraron los datos contables de la empresa.',
  'investments.operationFailed': 'No se pudo completar la operación. Inténtalo de nuevo.',
  'investments.measurement': 'Política de valoración documentada',
  'investments.cost': 'Coste con deterioro',
  'investments.fair_value': 'Valor razonable (admisibilidad documentada)',
  'investments.measurementReview': 'Documenta la política de valoración. El valor razonable requiere activos corrientes que cumplan los requisitos.',
  'investments.valueAboveCost': 'El valor contable no puede superar el coste según la política seleccionada.',
  'investments.duplicateInstrument': 'Esta clase de inversión ya está registrada. Usa un único instrumento para todos los proveedores.',
  'investments.receiptAlreadyBooked': 'El recibo ya está contabilizado. Usa los documentos de la empresa como evidencia que cubra varios eventos.',
  'investments.bankMatched': 'Conciliado con el banco',
  'investments.matchBank': 'Conciliar movimiento bancario',
  'investments.bankMatchInvalid': 'Actualiza y comprueba la fecha, el importe y la cuenta del banco antes de conciliar.',
  'investments.bankUnmatchRequired': 'Reabre la conciliación en la conciliación bancaria antes de revertir el evento.',
  'investments.acquisitionDate': 'Fecha de adquisición original (FIFO)',
  'nav.investeringer': 'Inversiones',
  'route.investeringer': 'Inversiones',
  'navhelp.investeringer': 'Acciones, fondos y contabilidad de inversiones.',
  'investments.title': 'Inversiones',
  'investments.subtitle': 'Acciones, fondos y eventos documentados',
  'investments.newInstrument': 'Nueva inversión',
  'investments.newEvent': 'Nuevo evento',
  'investments.name': 'Nombre',
  'investments.kind': 'Tipo',
  'investments.share': 'Acción',
  'investments.fund': 'Fondo',
  'investments.isin': 'ISIN (opcional)',
  'investments.issuerCountry': 'Código de país del emisor',
  'investments.accountCode': 'Cuenta de activo',
  'investments.valuationAccountCode': 'Cuenta de ajuste de valoración',
  'investments.taxTreatment': 'Tratamiento fiscal',
  'investments.accountSource.saved_instrument': 'Continúa con la cuenta ya guardada para la inversión.',
  'investments.accountSource.opening_balance': 'Sugerida a partir de un nombre y un saldo inequívocos del balance de apertura.',
  'investments.accountSource.manual': 'La cuenta se seleccionó manualmente y se reutilizará para la inversión.',
  'investments.accountSource.default': 'No se encontró ninguna cuenta histórica inequívoca. Se sugiere la cuenta 1810 sin bloquear la contabilidad.',
  'investments.review': 'Requiere revisión',
  'investments.exempt': 'Método de exención',
  'investments.taxable': 'Totalmente tributable',
  'investments.mixed': 'Capital e intereses mixtos',
  'investments.taxReason': 'Evidencia del tratamiento fiscal',
  'investments.instrumentId': 'Inversión',
  'investments.choose': 'Elegir',
  'investments.instrumentScope': 'NOK y NRS 8. Confirma la jurisdicción, el marco normativo y la categoría fiscal con la evidencia. Los fondos mixtos requieren una revisión aparte.',
  'investments.date': 'Fecha de contabilización',
  'investments.reference': 'Referencia única de la transacción',
  'investments.quantity': 'Cantidad',
  'investments.provider': 'Proveedor / cuenta de custodia',
  'investments.targetProvider': 'Nueva cuenta de custodia',
  'investments.lotId': 'Lote de adquisición fiscal',
  'investments.gross': 'Ingresos brutos / distribución',
  'investments.fees': 'Costes de transacción / comisión',
  'investments.bookCost': 'Coste contable',
  'investments.bookValue': 'Valor contable',
  'investments.taxCost': 'Coste fiscal',
  'investments.settlementAccount': 'Cuenta de liquidación',
  'investments.evidence': 'Evidencia',
  'investments.taxConfirmed': 'He comprobado el tratamiento fiscal de este evento y de este ejercicio fiscal.',
  'investments.opening': 'Posición de apertura',
  'investments.purchase': 'Compra',
  'investments.sale': 'Venta',
  'investments.dividend': 'Dividendo / distribución',
  'investments.annual_income': 'Intereses anuales declarados del fondo',
  'investments.annualIncomeHelp': 'Úsalo solo cuando el proveedor documente que los intereses del extracto anual son una observación informativa, sin pago en efectivo, sin nuevas participaciones y sin cambio en el coste contable o fiscal. No se crea ningún asiento.',
  'investments.liquidation': 'Liquidación',
  'investments.fee_redemption': 'Reembolso para pagar una comisión',
  'investments.transfer': 'Traspaso de cuenta de custodia',
  'investments.split': 'División o conversión de clase de acciones',
  'investments.demerger': 'Escisión',
  'investments.cost_basis_adjustment': 'Ajuste de la base de coste',
  'investments.valuation': 'Valoración',
  'investments.targetInstrumentId': 'Inversión receptora',
  'investments.bookCostAdjustment': 'Ajuste del coste contable',
  'investments.bookValueAdjustment': 'Ajuste del valor contable',
  'investments.taxCostAdjustment': 'Ajuste del coste fiscal',
  'investments.adjustmentAccount': 'Cuenta de contrapartida',
  'investments.demergerHelp': 'Introduce la cantidad y las bases documentadas que se traspasan de esta inversión a la inversión receptora. El evento no genera ganancia, pérdida ni movimiento bancario.',
  'investments.costBasisAdjustmentHelp': 'Usa importes de ajuste con signo. Un ajuste del valor contable requiere una cuenta de contrapartida documentada.',
  'investments.yearEndAssessment': 'Evaluación de fin de ejercicio',
  'investments.yearEndAssessmentHelp': 'Confirma con la evidencia que la posición se mantiene a coste y que no se requiere deterioro.',
  'investments.saveYearEndAssessment': 'Guardar evaluación',
  'investments.transferHelp': 'Traspasa el lote completo. Las bases históricas no cambian y no se crea ningún movimiento bancario.',
  'investments.openingHelp': 'Registra las posiciones ya incluidas en el saldo de apertura del libro mayor. No se contabiliza ningún asiento adicional. Concilia con el libro mayor.',
  'investments.dividendTaxFraction': 'Fracción tributable de la distribución',
  'investments.dividendThree': '3 % — método de exención ordinario',
  'investments.dividendZero': '0 % — excepción documentada',
  'investments.valuationTreatment': 'Tipo de diferencia fiscal',
  'investments.temporary': 'Diferencia temporal',
  'investments.permanent': 'Diferencia permanente',
  'investments.saveDraft': 'Guardar',
  'investments.uploadFirst': 'Primero sube la evidencia a Documentación o a Documentos en los ajustes.',
  'investments.loading': 'Cargando inversiones…',
  'investments.unavailable': 'No se pudieron cargar las inversiones.',
  'investments.supportScope': 'AS noruega, NOK y NRS 8, ejercicios fiscales 2024–2026. Un tratamiento fiscal sin resolver o mixto requiere revisión.',
  'investments.holdings': 'Posiciones',
  'investments.events': 'Eventos',
  'investments.closing': 'Conciliación y cierre del ejercicio',
  'investments.eventsHelp': 'Compras, ventas y otros cambios documentados en el registro de inversiones.',
  'investments.noEvents': 'No hay eventos en este periodo',
  'investments.noEventsHelp': 'Las nuevas compras y otros cambios aparecen aquí después de registrarse o importarse desde la bandeja de inversiones.',
  'investments.ai': 'Procesamiento con IA',
  'investments.aiBatchTitle': 'Procesamiento de inversiones con IA',
  'investments.aiBatchIntro': 'Sube juntas todas las evidencias de inversión del año. Plumme lee los documentos, separa los eventos de la evidencia de control y reúne los elementos que requieren revisión.',
  'investments.aiBatchLockedHelp': 'La subida masiva y el procesamiento consolidado con IA requieren una suscripción activa de Plumme. La bandeja y el registro manual siguen disponibles.',
  'investments.aiBatchActivate': 'Ver suscripción',
  'investments.aiBatchUpload': 'Subir todos los documentos',
  'investments.aiBatchSourceOpening': 'Balance de apertura y extracto anual anterior',
  'investments.aiBatchSourceTransactions': 'Compras, ventas, escisiones y cambios en la base de coste',
  'investments.aiBatchSourceBank': 'Extractos bancarios y comisiones',
  'investments.aiBatchSourceAnnual': 'Extracto anual o informe de diciembre',
  'investments.aiBatchSummary': 'Estado del procesamiento con IA',
  'investments.aiBatchDocuments': 'Documentos leídos',
  'investments.aiBatchPrepared': 'Preparado',
  'investments.aiBatchEvidence': 'Evidencia de control',
  'investments.aiBatchExceptions': 'Excepciones',
  'investments.aiBatchProposalTitle': 'Base de trabajo consolidada',
  'investments.aiBatchProposalHelp': 'Todas las líneas interpretadas se muestran juntas. Usa el lápiz para corregir un dato de origen. No se contabiliza nada hasta que se apruebe la propuesta.',
  'investments.aiBatchEmpty': 'Sube los documentos para construir la base de trabajo consolidada.',
  'investments.aiBatchOpenArchive': 'Abrir archivo de documentos',
  'investments.aiBatchApprovalLater': 'La propuesta de contabilización consolidada y la aprobación final se generan en el siguiente paso.',
  'investments.aiBatchPostingTitle': 'Paquete de contabilización consolidado',
  'investments.aiBatchPostingHelp': 'Esta es la contabilidad propuesta real. Edita los datos de origen; FIFO, ganancias/pérdidas y líneas del asiento se recalculan.',
  'investments.aiBatchPreparing': 'Generando el paquete de contabilización …',
  'investments.aiBatchNoDrafts': 'No hay borradores de eventos pendientes listos para contabilizar.',
  'investments.aiBatchRefreshPackage': 'Recalcular',
  'investments.aiBatchFinalApprove': 'Aprobar el paquete de inversiones completo',
  'investments.debit': 'Debe',
  'investments.credit': 'Haber',
  'investments.fifo': 'Lotes FIFO',
  'investments.yearEndBankMissing': 'Falta un vínculo bancario.',
  'investments.yearEndBankAmbiguous': 'El vínculo bancario es ambiguo.',
  'investments.yearEndBankMatchFailed': 'No se pudo guardar el vínculo bancario.',
  'investments.missing_tax_realization_confirmation': 'Falta la confirmación de la realización fiscal.',
  'investments.missingTaxRealizationOverrideHelp': 'El informe de diciembre no documenta las realizaciones fiscales. Sube el extracto anual o de realizaciones, o documenta por qué omites este control.',
  'investments.overrideReason': 'Motivo y consecuencia',
  'investments.recordOverride': 'Registrar excepción auditada',
  'investments.aiBatchStatus.prepared': 'Listo para la propuesta',
  'investments.aiBatchStatus.draft': 'Borrador',
  'investments.aiBatchStatus.posted': 'Contabilizado',
  'investments.aiBatchStatus.evidence': 'Evidencia de control',
  'investments.aiBatchStatus.exception': 'Requiere revisión',
  'investments.investmentAiBatchSubscriptionRequired': 'Se requiere una suscripción activa para el procesamiento consolidado con IA.',
  'investments.refresh': 'Actualizar',
  'investments.edit': 'Editar',
  'investments.empty': 'Registra una inversión y luego añade posiciones de apertura o una compra.',
  'investments.status': 'Estado',
  'investments.actions': 'Acciones',
  'investments.draft': 'Borrador',
  'investments.posted': 'Aprobado',
  'investments.reversed': 'Revertido',
  'investments.preview': 'Revisar propuesta de contabilización',
  'investments.discard': 'Descartar borrador',
  'investments.reverse': 'Revertir evento',
  'investments.reconciliation': 'Conciliar con el libro mayor',
  'investments.ledgerValue': 'Libro mayor',
  'investments.difference': 'Diferencia',
  'investments.closingHelp': 'Registra una valoración documentada al 31 de diciembre para cada posición. Resuelve las diferencias y los borradores antes de traspasar los ajustes fiscales. Las posiciones continúan en el año siguiente.',
  'investments.taxDifferences': 'Diferencias fiscales',
  'investments.note': 'Base de la nota de valores',
  'investments.reviewNote': 'Nota de revisión',
  'investments.reviewClosing': 'Aprobar la conciliación y traspasar las diferencias fiscales',
  'investments.closingReviewed': 'Base de inversiones revisada y traspasada.',
  'investments.proposal': 'Propuesta de contabilización',
  'investments.noJournal': 'Actualiza el registro sin un asiento contable adicional.',
  'investments.bookProfit': 'Resultado contable',
  'investments.taxProfit': 'Resultado fiscal',
  'investments.approve': 'Aprobar y contabilizar',
  'investments.existingPostingTitle': 'Ya contabilizado',
  'investments.existingPostingHelp': 'Este asiento concilia con todos los eventos de la fecha. Vincula los eventos sin volver a contabilizarlos.',
  'investments.existingPostingNote': 'Nota de conciliación',
  'investments.linkExistingPosting': 'Vincular a {{voucher}} ({{count}} eventos)',
  'investments.reverseHelp': 'Revierte primero los eventos aprobados posteriores. La reversión usa el periodo abierto original y queda en el historial de auditoría.',
  'investments.confirmReverse': 'Confirmar reversión',
  'investments.evidenceRequired': 'Se requieren la evidencia y una referencia única.',
  'investments.quantityRequired': 'Introduce una cantidad positiva.',
  'investments.lotQuantityInvalid': 'La cantidad supera las posiciones. El coste fiscal usa FIFO.',
  'investments.feeMustMatchRedemption': 'La comisión y el importe del reembolso deben coincidir.',
  'investments.dividendFeesReview': 'Las distribuciones con comisiones requieren una revisión aparte.',
  'investments.fullLotTransferRequired': 'Selecciona el lote completo y una nueva cuenta de custodia.',
  'investments.positionRequired': 'Registra primero una posición.',
  'investments.valuationTaxReview': 'Revisa el tratamiento fiscal de la valoración.',
  'investments.annualIncomeScopeReview': 'Los intereses anuales declarados del fondo solo se admiten para fondos documentados como totalmente tributables.',
  'investments.annualIncomeDateRequired': 'Los intereses anuales declarados del fondo deben tener fecha 31 de diciembre.',
  'investments.taxReviewRequired': 'Revisa y documenta el tratamiento fiscal.',
  'investments.bankAccountRequired': 'Elige una cuenta bancaria activa.',
  'investments.demergerTargetRequired': 'Selecciona para la escisión una inversión receptora distinta.',
  'investments.demergerBasisInvalid': 'Las bases traspasadas no pueden superar la posición de origen.',
  'investments.demergerMeasurementUnsupported': 'Las escisiones requieren actualmente que ambas inversiones usen valoración a coste.',
  'investments.basisAdjustmentRequired': 'Introduce al menos un ajuste de base.',
  'investments.basisAdjustmentInvalid': 'El ajuste dejaría una base en negativo.',
  'investments.basisAdjustmentMeasurementUnsupported': 'Los ajustes de base requieren actualmente valoración a coste.',
  'investments.adjustmentAccountRequired': 'Selecciona una cuenta de contrapartida cuando cambie el valor contable.',
  'investments.openingYearInvalid': 'El extracto solo puede establecer saldos de apertura para su año de informe, o para el año siguiente si tiene fecha 31 de diciembre.',
  'investments.unbalanced': 'La propuesta no cuadra.',
  'investments.dateInvalid': 'Elige una fecha válida.',
  'investments.scopeUnsupported': 'Este flujo admite AS noruegas en 2024–2026.',
  'investments.amountRequired': 'Falta un importe obligatorio.',
  'investments.amountInvalid': 'Comprueba el importe.',
  'investments.instrumentInvalid': 'Comprueba el tipo de inversión, la cuenta y el marco normativo.',
  'investments.instrumentReviewRequired': 'Documenta el tratamiento fiscal de la inversión.',
  'investments.evidenceNotFound': 'No se encontró la evidencia en esta empresa.',
  'investments.eventInvalid': 'Evento no válido.',
  'investments.dividendFractionInvalid': 'Elige una fracción tributable documentada.',
  'investments.instrumentHasHistory': 'Una inversión con eventos aprobados no se puede editar directamente.',
  'investments.issuerCountryRequired': 'Introduce el país del emisor.',
  'investments.instrumentNotFound': 'No se encontró la inversión.',
  'investments.eventImmutable': 'Usa la reversión para los eventos aprobados.',
  'investments.duplicateEvent': 'Ya existe un evento con esta referencia.',
  'investments.eventNotFound': 'No se encontró el evento.',
  'investments.chronologyRequired': 'Aprueba los eventos por orden de fecha.',
  'investments.openingMustPrecedeActivity': 'Las posiciones de apertura deben tener fecha 1 de enero, antes de cualquier otra actividad.',
  'investments.proposalStale': 'La base ha cambiado. Solicita una nueva propuesta.',
  'investments.reverseLatestFirst': 'Revierte primero el último evento aprobado.',
  'investments.existingPostingMismatch': 'El asiento existente no concilia con la liquidación combinada de las inversiones.',
  'investments.existingPostingUnlinkRequired': 'Elimina el vínculo con el asiento existente antes de revertir el evento.',
  'investments.reasonRequired': 'Introduce un motivo.',
  'investments.actionInvalid': 'Acción no admitida.',
  'investments.documentPostedCannotDelete': 'Un documento de inversión contabilizado no se puede mover a la papelera.',
  'investments.documentInUseCannotTrash': 'El documento se usa en un borrador de inversión. Elimina el borrador antes de mover el documento a la papelera.',
  'investments.sourceReviewedConfirmation': 'He comprobado visualmente el documento original con el importe, la fecha, la inversión y la cantidad.',
  'investments.draftsPending': 'Hay borradores sin procesar.',
  'investments.ledgerMismatch': 'El registro y el libro mayor difieren.',
  'investments.valuationRequired': 'Falta la valoración de fin de ejercicio de',
  'investments.holdingQuantityMismatch': 'La posición documentada a fin de ejercicio difiere de la cantidad registrada de',
  'investments.closingReviewRequired': 'Revisa las inversiones antes de cerrar el ejercicio.',
  'investments.taxPackageChanged': 'Los ajustes fiscales han cambiado. Concilia y traspasa de nuevo.',
  'investments.useInvestmentWorkflow': 'Modifica este asiento desde Inversiones.',
});
